<template>
  <div style="text-align: center">
    <div style="width: 90%; text-align: center; margin: 0 auto">
      <p class="title is-2" v-if="width < 1100"> Your certificate is ready! <br><br>  </p> 
      <Button @click="download" id="downloadButton" :style="{ fontSize: width < 1100 ? '20px' : '40px'}"> Download Certificate</Button>
      <br><br>
    </div>
    
    <canvas v-show="width > 1100" id="canvas" style="border: 1px solid grey" @click="download"></canvas>
    <br>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {
  },
  data() {
    return {
      canvas: null,
      width: 1100,
      name: ""
    };
  },
  computed: {
    
  },
  methods: {
    doCanvas() {

    },
    download() {
      var link = document.createElement('a');
      link.href = this.canvas.toDataURL('image/jpeg');
      link.download = this.getUrlParam('name') + ' Certificate.png'
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    },
    getUrlParam: function (str) {
      var url = new URL(window.location.href)
      return url.searchParams.get(str) || ''
    },
  },
  mounted() {
    console.log("Mounted")
    this.width = window.innerWidth;
    var canvas = document.getElementById("canvas")
    this.canvas = canvas
    var ctx = canvas.getContext("2d");
    
    console.log(window.innerWidth)
    // var ratio = 850 / 1100
    // var w = Math.min(1100, window.innerWidth * 0.9)
    // canvas.width = w
    // var h = ratio * w
    // canvas.height = h
    // console.log(w, h)
    canvas.width = 1000 // 1176
    canvas.height = 707 // 1346


    var background = new Image();
    background.crossOrigin="anonymous"
    background.src = "https://mindstamp-resources.s3.us-west-2.amazonaws.com/clients/foresters/f-eng.png";
    var img = background
    // Make sure the image is loaded first otherwise nothing will draw.
    background.onload = function(){
        ctx.drawImage(img, 0, 0, img.width,    img.height,     // source rectangle
            0, 0, canvas.width, canvas.height);
    }
    ctx.globalCompositeOperation='destination-over';

    // ctx.fillStyle = "#253f8e";
    ctx.font = "bold 20px Arial";
    
    this.name = this.getUrlParam("name") || "VIEWER_NAME"
    var name = this.name.toUpperCase()
    console.log("Name Length: " + name.length)
    // if (name.length > 35) {
    //   ctx.font = 'bold 28px Arial'
    // } else if (name.length > 20) {
    //   ctx.font = 'bold 36px Arial'
    // }
    
    var text = ctx.measureText(name)
    console.log(text)
    ctx.fillText(name, (canvas.width / 2) - text.width / 2 , (canvas.height / 4) - 25);

    

    // ctx.fillStyle = "#253f8e";
    ctx.font = "bold 16px Arial";
    
    var c = this.getUrlParam("course") || "20/20 Insurance Vision Digital Course"
    var course = c.toUpperCase()
    console.log("Name Length: " + name.length)
    // if (name.length > 35) {
    //   ctx.font = 'bold 28px Arial'
    // } else if (name.length > 20) {
    //   ctx.font = 'bold 36px Arial'
    // }
    
    var text = ctx.measureText(course)
    console.log(text)
    ctx.fillText(course, (canvas.width / 2) - text.width / 2 , (canvas.height / 3) - 20);




    
    // ctx.font = "bold 32px Arial";
    // var course = this.getUrlParam("course") || "Drug and Alcohol Awareness"
    // text = ctx.measureText(course)
    // ctx.fillText(course, (canvas.width / 2) - text.width / 2, (canvas.height / 2) + 60);
    
    ctx.font = "bold 20px Arial";
    ctx.fillStyle = "#000000";
    ctx.background = 'yellow'
    var d = new Date()
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var date = months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear()
    text = ctx.measureText(z)
    var z = new Date().toLocaleDateString()
    ctx.letterSpacing = "2px";
    ctx.fillText(z, (canvas.width / 2) - text.width / 2 + 260, (canvas.height / 2) - 137);



    ctx.font = "bold 20px Arial";
    var license = (this.getUrlParam("license") || "").toUpperCase()
    ctx.letterSpacing = "2px";
    ctx.fillText(license, (canvas.width / 2) - text.width / 2 + 130, (canvas.height / 2) - 107);

    // ctx.font = "bold 16px Arial";
    // var issuer = this.getUrlParam("issuer") || "Coralee Olson"
    // text = ctx.measureText(issuer)
    // ctx.fillText(issuer.toUpperCase(), (canvas.width * 1 / 4)  +30 - text.width / 2, (canvas.height / 2) + 190);

    // Draw whatever else over top of it on the canvas.
  },
};
</script>

<style scoped lang="scss">
  canvas {
    background-size: 100% 100%;
    cursor: pointer;
  }

  #app {
    text-align: center
  }

  #downloadButton {
    background: #1e6eb0;
    color: white;
    width: auto;
    height: auto;
    padding: 15px 25px;
    border: 1px solid white;
    border-radius: 10px;
    font-size: 24px;
    cursor: pointer;

  }
</style>